// SelectMultiple
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import React from 'react';
import { generatePublicUrl } from '../../urlConfig';
import RenderMiniImg from '../../components/Button/RenderMiniImg';

const getDefaultPicture = (product) => {
    if (!product || !Array.isArray(product.productPictures) || !product.productPictures.length) {
        return null;
    }

    const mainPicture = product.productPictures.find((picture) => picture.mainImg);

    if (mainPicture) {
        return mainPicture;
    }

    const visiblePicture = product.productPictures.find((picture) => picture.visibleImg !== false);

    if (visiblePicture) {
        return visiblePicture;
    }

    return product.productPictures[0];
};

const getProductImage = (product) => {
    const picture = getDefaultPicture(product);

    return picture?.img || product?.reducedImage || "";
};

const SelectMultiple = ({
    items = [],
    productIds = [],
    selectedProduct,
    setSelectedProduct,
    setProductIds,
}) => {
    const safeItems = Array.isArray(items) ? items : [];
    const safeProductIds = Array.isArray(productIds) ? productIds : [];

    const handleProductIdsChange = (event) => {
        const selectedIds = event.target.value;

        const newProducts = selectedIds.map((productId, index) => {
            const item = safeItems.find((prod) => prod._id === productId);
            const picture = getDefaultPicture(item);
            const img = getProductImage(item);

            return {
                productId,
                selectedPictureId: picture?._id || null,
                img,
                reducedImage: item?.reducedImage || img,
                order: index + 1
            };
        });

        setProductIds(newProducts);
    };

    const handleDeleteProduct = (productId) => {
        const updatedProductIds = safeProductIds.filter((product) => product.productId !== productId);
        setProductIds(updatedProductIds);
    };

    return (
        <div className="selectMultiple">
            <FormControl
                fullWidth
                margin="normal"
                className="selectMultiple__control"
            >
                <InputLabel className="selectMultiple__label">
                    Товары
                </InputLabel>

                <Select
                    multiple
                    className="selectMultiple__select"
                    value={safeProductIds.map((product) => product.productId)}
                    onChange={handleProductIdsChange}
                    renderValue={() => safeProductIds.length > 0 ? `${safeProductIds.length} позиций выбрано` : ""}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                        },
                        PaperProps: {
                            className: "selectMultiple__paper"
                        },
                        MenuListProps: {
                            className: "selectMultiple__menuList"
                        }
                    }}
                >
                    {safeItems.map((prod) => {
                        const img = getProductImage(prod);
                        const selected = safeProductIds.some((item) => item.productId === prod._id);

                        return (
                            <MenuItem
                                className={selected
                                    ? "selectMultiple__item selectMultiple__item--selected"
                                    : "selectMultiple__item"
                                }
                                key={prod._id}
                                value={prod._id}
                                onMouseEnter={() => setSelectedProduct(img)}
                                onMouseLeave={() => setSelectedProduct(null)}
                            >
                                <span className="selectMultiple__itemName">
                                    {prod.fullName || prod.name || "Без названия"}
                                </span>

                                <span className="selectMultiple__itemMeta">
                                    {prod.categoryName || "Без категории"}
                                </span>

                                {!prod.visibleProduct && (
                                    <span className="selectMultiple__visibleProductText">
                                        Скрытый товар
                                    </span>
                                )}
                            </MenuItem>
                        );
                    })}
                </Select>

                {selectedProduct && (
                    <div className="selectMultiple__preview">
                        <img
                            src={generatePublicUrl(selectedProduct)}
                            alt=""
                        />
                    </div>
                )}

                <RenderMiniImg
                    itemObj={safeProductIds}
                    onClickIcon={handleDeleteProduct}
                    tooltip="Удалить"
                />
            </FormControl>
        </div>
    );
};

export default SelectMultiple;